import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import i18next from 'i18next';
import DashboardNavbar from './components/navbar/index';
import { Box } from '@mui/material';
import { SubNavbar } from './components/subNavbar';
import { MobileSideBar } from './components/mobileSidebar';
import { UserService } from '../../../../services/userService';

// Matches FundingSouq.Common.Enums.Language on the backend.
const BackendLanguage = { en: 1, ar: 2 };

const RootStyle = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	minHeight: '100%',
	overflow: 'hidden',
});

const MainStyle = styled('div')(({ theme }) => ({
	flexGrow: 1,
	overflow: 'hidden',
	minHeight: '100%',
	paddingTop: theme.spacing(3),
	paddingBottom: theme.spacing(1),
	paddingLeft: theme.spacing(1),
	paddingRight: theme.spacing(1),
	backgroundColor: '#f5f5f5',
	[theme.breakpoints.up('md')]: {
		paddingTop: theme.spacing(0),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		paddingBottom: theme.spacing(0),
		paddingLeft: theme.spacing(1),
		paddingRight: theme.spacing(1),
	},
}));

const BorrowerLayout = () => {
	const [open, setOpen] = useState(false);

	useEffect(() => {
		const currentLanguage = BackendLanguage[i18next.language];
		if (currentLanguage) {
			new UserService().updatePreferredLanguage(currentLanguage).catch(() => {});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<RootStyle>
			<Box>
				<DashboardNavbar onOpenSidebar={() => setOpen(true)} />
				<SubNavbar></SubNavbar>
				<MobileSideBar
					isOpenSidebar={open}
					onCloseSidebar={() => setOpen(false)}></MobileSideBar>
			</Box>
			<MainStyle className='md:!pt-0'>
				<Box className="xl:w-[1140px] w-full py-3 sm:py-0 md:py-3 lg:py-3 md:mt-0 mt-[55px]">
					<Outlet />
				</Box>
			</MainStyle>
		</RootStyle>
	);
};
export default BorrowerLayout;
